import React, { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import styles from '@danske/sapphire-css/components/backdrop/backdrop.module.css';
import {
  SapphireStyleProps,
  useSapphireStyleProps,
  useThemeCheck,
} from '../../utils';
import { GlobalDomAttributes } from '../../utils/types';
import { filterDOMProps } from 'react-aria/filterDOMProps';

export interface BackdropProps extends GlobalDomAttributes, SapphireStyleProps {
  children: ReactNode;
  underlayProps?: HTMLAttributes<HTMLDivElement>;
  isVisible?: boolean;
}

export const Backdrop = (props: BackdropProps): JSX.Element => {
  useThemeCheck();

  const { children, underlayProps, ...rest } = props;
  const { styleProps } = useSapphireStyleProps(props);
  const { isVisible = true } = props;

  return (
    <div
      {...filterDOMProps(rest, { global: true })}
      data-testid="sapphire-backdrop"
      className={clsx(styleProps.className, styles['sapphire-backdrop'], {
        [styles['sapphire-backdrop--exiting']]: !isVisible,
      })}
      style={styleProps.style}
      {...underlayProps}
    >
      {children}
    </div>
  );
};
